import * as Blockly from "blockly";

export function createRegisteredField<T = unknown>(fieldName: string, ...args: unknown[]): Blockly.Field<T> {
  const fieldClass = (Blockly.fieldRegistry as any).getClass?.(fieldName)
    ?? (Blockly.registry as any).getClass?.((Blockly.registry as any).Type.FIELD, fieldName);
  if (!fieldClass) {
    throw new Error(`Blockly field "${fieldName}" is not registered. Call registerBlocklyFields() before registerBlocklyMutators().`);
  }
  return new fieldClass(...args) as Blockly.Field<T>;
}

export function createPlusMinusField(isPlus: boolean): Blockly.Field<string> {
  return createRegisteredField<string>("field_plus_minus", isPlus);
}

export function createChevronField(expanded: boolean): Blockly.Field<boolean> {
  return createRegisteredField<boolean>("field_chevron", expanded);
}

export function registerMutatorIfMissing(
  name: string,
  mixin: object,
  helperFn?: any,
  blockList?: string[],
): void {
  if (Blockly.Extensions.isRegistered(name)) return;
  Blockly.Extensions.registerMutator(name, mixin, helperFn ?? undefined, blockList ?? []);
}
